
import { Component, Prop, Vue } from "vue-property-decorator";
import { NewResultX } from "@/lib/model/exam/result";

// 单维度心理测评结果枚举
enum singleDimensionMindRes {
  "低风险",
  "中风险",
  "高风险"
}

@Component
export default class Mandarin extends Vue {
  @Prop({ type: NewResultX, default: new NewResultX() }) mindRes!: NewResultX;
  @Prop({ type: Boolean, default: false }) isH5!: boolean;

  mindTypeClass = `mindType_${this.mindRes.isMatch}`;

  mindResText(i: number) {
    return singleDimensionMindRes[i];
  }
}
